import { render, staticRenderFns } from "./PostalSeparateInputs.de.es.fr.it.vue?vue&type=template&id=3a879098"
import script from "./PostalSeparateInputs.de.es.fr.it.vue?vue&type=script&lang=js"
export * from "./PostalSeparateInputs.de.es.fr.it.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports